import { render, staticRenderFns } from "./ModalActDGLot.vue?vue&type=template&id=9a452d74&"
import script from "./ModalActDGLot.vue?vue&type=script&lang=js&"
export * from "./ModalActDGLot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports